import get from 'lodash/get'

export default {
  data() {
    return {
      error: null,
      isProcessing: false,
    }
  },

  methods: {
    handleError(error) {
      this.error = get(error, 'response.data', {
        message: 'Something went wrong.',
      })
    },

    async handleRequest(callback) {
      this.isProcessing = true
      this.error = null

      try {
        await callback()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isProcessing = false
      }
    },

    getFieldError(key) {
      return get(this.error, ['fieldErrors', key])
    },

    getFieldErrors() {
      return Object.entries(get(this.error, 'fieldErrors', {}))
    },

    getRequestError() {
      return get(this.error, 'message')
    },
  },
}
